import "./Policy.scss"

export default function Policy() {
    return (
        <section className="Policy">
            <h1 className="Policy__title">ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ FLEEKA.RU</h1><br />
            <br />
            Дата вступления в силу: 14.03.2024<br />
            <br />
            <br />
            Владелец информационного сервиса Флика: Бунчук Валерий Сергеевич, самозанятый, ИНН 362709453177 (далее — «Оператор сервиса»). Данное Пользовательское соглашение регулирует использование информационного сервиса (далее — «Сервис») пользователем сайта.<br />
            <br />
            <br />
            1. ОПРЕДЕЛЕНИЕ УСЛУГ<br />
            <br />
            1.1. Флика — информационный сервис: принимает заявки на междугородние поездки и передаёт их водителям. Флика не является перевозчиком или автопарком. Саму поездку выполняет отдельный водитель или перевозчик. Городские поездки сервис не принимает.<br />
            1.2. Калькулятор показывает предварительную стоимость и не подтверждает заказ. До поездки необходимо согласовать исполнителя, точные адреса, время, багаж, окончательную стоимость и условия с диспетчером. Платные дороги оплачиваются отдельно.<br />
            <br />
            <br />
            2. ОПЛАТА И ВОЗНАГРАЖДЕНИЕ<br />
            <br />
            2.1. Стоимость поездки и способ оплаты согласовываются до подтверждения заказа. Доступны наличные и безналичная оплата; реквизиты и удобный способ уточните у диспетчера.<br />
            <br />
            2.2. Предварительный расчёт на сайте не заменяет согласование окончательной стоимости конкретной поездки.<br />
            <br />
            <br />
            3. ОТМЕНА И ЗАКЛЮЧЕНИЕ СДЕЛКИ<br />
            <br />
            3.1. Условия отмены, предоплаты и ожидания уточните до подтверждения поездки. На сайте не установлены единые размеры платы за отмену или ожидание.<br />
            <br />
            3.2. Наличие расчёта не означает, что водитель назначен. Возможность подачи и исполнителя поездки необходимо подтвердить у диспетчера.<br />
            <br />
            <br />
            4. ОБЯЗАТЕЛЬСТВА И ОТВЕТСТВЕННОСТЬ СТОРОН<br />
            <br />
            4.1. Пользователь обязуется использовать Сервис с соблюдением всех применимых законов и правил.<br />
            <br />
            4.2. Оператор сервиса принимает и передаёт заявки. Фактическую перевозку выполняет отдельный исполнитель. Это описание ролей не ограничивает права пользователя и ответственность участников, предусмотренные применимым законодательством.<br />
            <br />
            <br />
            5. КОНФИДЕНЦИАЛЬНОСТЬ<br />
            <br />
            5.1. По вопросам обработки личной информации пользователь может обратиться к Оператору сервиса по адресу taxifleeka@yandex.ru. Не передавайте через форму калькулятора паспортные данные, платёжные реквизиты или другую информацию, не требующуюся для расчёта маршрута.<br />
            <br />
            <br />
            6. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ<br />
            <br />
            6.1. Актуальная редакция сведений об использовании сервиса размещается на этой странице.<br />
            <br />
            6.2. В случае возникновения споров, стороны обязуются разрешать их путем переговоров.<br />
            <br />
            <br />
            Пользуясь Сервисом, Пользователь выражает свое согласие с условиями настоящего Соглашения. Если вы не согласны с этими условиями, прекратите использование Сервиса.<br />
            <br />
            <br />
            <center>
            FLEEKA<br />
            <a href="mailto:taxifleeka@yandex.ru">taxifleeka@yandex.ru</a><br />
            Бунчук Валерий Сергеевич · ИНН 362709453177<br />
            Офис: Россошь, площадь Ленина, 2А. Приём: пн–пт, 10:00–15:00.<br />
            Дата уточнения реквизитов и описания сервиса: 23.09.2026
            </center>
        </section>
    )
}
